export default (searchTerm) => {
  let sanitizedSearchTerm = searchTerm.replace(/-/g, ' ')
  sanitizedSearchTerm = sanitizedSearchTerm.replace(/%20/g, ' ')
  return sanitizedSearchTerm
}
